// Imports
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const BANK_CONTRIBUTION_USER_GROUPS = ['cimb', 'bsi','admin', 'maybank']

function isBankContributionUser() {
  const userGroup = String(localStorage.getItem('website_users_group') || '')
    .trim()
    .toLowerCase()

  return BANK_CONTRIBUTION_USER_GROUPS.includes(userGroup)
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash }
    if (savedPosition) return savedPosition

    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      component: () => import('@/layouts/home/Index.vue'),
      children: [
        {
          path: '',
          name: '',
          redirect: '/beranda',
          component: () => import('@/views/home/Index.vue'),
          meta: { menubar: true, tabs: 0, description: 'PT Asuransi Takaful Umum Merupakan Pionir Dalam Perusahaan Asuransi Umum Syariah Yang Telah Melayani Masyarakat Indonesia Sejak 1995' },
        },
        {
          path: 'beranda',
          name: 'beranda',
          component: () => import('@/views/home/Index.vue'),
          meta: { menubar: true, tabs: 0, description: 'PT Asuransi Takaful Umum Merupakan Pionir Dalam Perusahaan Asuransi Umum Syariah Yang Telah Melayani Masyarakat Indonesia Sejak 1995' },
        },
        {
          path: 'verified-policy/:id',
          name: 'verified-policy',
          component: () => import('@/views/verifiedpolicy/Index.vue'),
          meta: { menubar: true },
        },
        {
          path: 'tentang-kami',
          name: 'tentang-kami',
          component: () => import('@/views/about/Index.vue'),
          meta: { menubar: true, src: require('@/assets/banner-company.jpg'), tabs: 1, description: 'Keinginan membentuk asuransi syariah di Indonesia sebenarnya sudah muncul sejak lama sebelum berdirinya bank syariah pertama, Bank Muamalat. Tekad itu semakin kuat manakala Bank Muamalat sudah benar-benar resmi beroperasi pada tanggal 1 Mei 1992. Baru pada tanggal 27 Juli 1993, para wakil dari Yayasan Abdi Bangsa, Bank Muamalat Indonesia, dan Asuransi Jiwa Tugu Mandiri, sebagai sponsor Team Pembentukan Asuransi Takaful Indonesia (TEPATI), berkumpul guna mewujudkan harapan besar tersebut. Team ini juga mendapat dukungan dari beberapa pejabat Departemen Keuangan dan sejumlah pengusaha muslim Indonesia.' },
        },
        {
          path: 'sejarah-takaful',
          name: 'sejarah-takaful',
          component: () => import('@/views/aboutusdetail/Index.vue'),
          meta: { menubar: true, src: require('@/assets/banner-history.jpg'), tabs: 1, description: 'PT Asuransi Takaful Umum sendiri berdiri pada tanggal 2 Juni 1995 atau bertepatan dengan 1 Muharam 1416 H berdasarkan Akta No. 46 tanggal 5 Mei 1994 di hadapan notaris Yudo Paripurno, SH, melalui SK Menteri Kehakiman RI No. C2.18.286.HT.01.01.TH.94 tertanggal 14 Desember 1994. Akta tersebut telah diumumkan dalam Berita Negara RI tanggal 21 Februari 1995 No. 15 Tambahan Berita Negara RI No. 1660 tahun 1995 yang telah diubah melalui Akta No. 93 tanggal 21 Juni 1996 yang telah diumumkan dalam Berita Negara RI tanggal 3 Juli 2001 Tambahan Berita Negara RI No. 4289 tahun 2001. Peresmiannya sendiri dilakukan di Hotel Shangri-La Jakarta oleh Menristek/Ketua BPPT, BJ Habibie, yang kala itu juga merupakan pendiri sekaligus Ketua Ikatan Cendekiawan Muslim Indonesia (ICMI).' },
        },
        {
          path: 'struktur-perusahaan',
          name: 'struktur-perusahaan',
          component: () => import('@/views/structure/Index.vue'),
          meta: { menubar: true, src: require('@/assets/banner-structure.jpg'), tabs: 1, description: 'Direktur Utama, Direktur Kepatuhan, Direktur Operasional PT Asuransi Takaful Umum' },
        },
        {
          path: 'struktur-pemegang-saham',
          name: 'struktur-pemegang-saham',
          component: () => import('@/views/shareholder/Index.vue'),
          meta: { menubar: true, src: require('@/assets/shareholder-structure.jpg'), tabs: 1, description: 'ShareHolder Structure PT Asuransi Takaful Umum' },
        },
        {
          path: 'penghargaan-perusahaan',
          name: 'penghargaan-perusahaan',
          component: () => import('@/views/awardsothers/Index.vue'),
          meta: { menubar: true, src: require('@/assets/banner-awards.jpg'), tabs: 1, description: 'Best Sharia General Insurance Indonesia' },
        },
        {
          path: 'penghargaan-detail/:url',
          name: 'penghargaan-detail',
          component: () => import('@/views/awardsdetail/Index.vue'),
          meta: { menubar: false, src: require('@/assets/contact.jpg'), tabs: 1, description: 'Best Sharia General Insurance Indonesia' },
        },
        {
          path: 'laporan-keuangan',
          name: 'laporan-keuangan',
          component: () => import('@/views/financialreport/Index.vue'),
          meta: { menubar: true, src: require('@/assets/banner-report.jpg'), tabs: 2, description: 'Laporan Keuangan PT Asuransi Takaful Umum' },
        },
        {
          path: 'laporan-tahunan',
          name: 'laporan-tahunan',
          component: () => import('@/views/undermaintenance/Index.vue'),
          meta: { menubar: true, src: require('@/assets/banner-nonfinancial.jpg'), tabs: 2, description: 'Laporan Non Keuangan PT Asuransi Takaful Umum' },
        },
        {
          path: 'laporan-nonkeuangan',
          name: 'laporan-nonkeuangan',
          component: () => import('@/views/nonfinancialreport/Index.vue'),
          meta: { menubar: true, src: require('@/assets/nonfinancial.jpg'), tabs: 2, description: 'Laporan Non Keuangan PT Asuransi Takaful Umum' },
        },
        {
          path: 'corporategovernance',
          name: 'corporategovernance',
          component: () => import('@/views/corporategovernance/Index.vue'),
          meta: { menubar: true, src: require('@/assets/banner-nonfinancial.jpg'), tabs: 2, description: 'Laporan Tata Kelola PT Asuransi Takaful Umum' },
        },
        {
          path: 'prospektus',
          name: 'prospektus',
          component: () => import('@/views/undermaintenance/Index.vue'),
          meta: { menubar: true, src: require('@/assets/banner-nonfinancial.jpg'), tabs: 2, description: 'Laporan Tata Kelola PT Asuransi Takaful Umum' },
        },
        {
          path: 'kalender-2024',
          name: 'kalender-2024',
          component: () => import('@/views/calendar/2024.vue'),
          meta: { menubar: true, src: require('@/assets/banner-report.jpg'), tabs: 1, description: 'Kalender PT Asuransi Takaful Umum' },
        },
        {
          path: 'kalender-2025',
          name: 'kalender-2025',
          component: () => import('@/views/calendar/2025.vue'),
          meta: { menubar: true, src: require('@/assets/banner-report.jpg'), tabs: 1, description: 'Kalender PT Asuransi Takaful Umum' },
        },
        {
          path: 'produk',
          name: 'produk',
          component: () => import('@/views/products/Index.vue'),
          meta: { menubar: true, src: require('@/assets/banner-product.jpg'), tabs: 1, description: 'Takaful Abror, Takaful Kendaraan Bermotor, Takaful Properti, Takaful Baituna, Takaful Safari, Takaful PA Siswa, Takaful Kargo, Takaful Marine Hull, Takaful Professional Liability' },
        },
        {
          path: 'produk-detail/:url',
          name: 'produk-detail',
          component: () => import('@/views/productsdetail/Index.vue'),
          meta: { menubar: true, src: require('@/assets/pro.jpg'), tabs: 1, description: 'Takaful Abror, Takaful Kendaraan Bermotor, Takaful Properti, Takaful Baituna, Takaful Safari, Takaful PA Siswa, Takaful Kargo, Takaful Marine Hull, Takaful Professional Liability' },
        },
        {
          path: 'produk-detail-cob/:url',
          name: 'produk-detail-cob',
          component: () => import('@/views/productsdetailcob/Index.vue'),
          meta: { menubar: true, src: require('@/assets/pro.jpg'), tabs: 1, description: 'Takaful Abror, Takaful Kendaraan Bermotor, Takaful Properti, Takaful Baituna, Takaful Safari, Takaful PA Siswa, Takaful Kargo, Takaful Marine Hull, Takaful Professional Liability' },
        },
        {
          path: 'berita-lainnya',
          name: 'berita-lainnya',
          component: () => import('@/views/news/Index.vue'),
          meta: { menubar: true, src: require('@/assets/banner-news.jpg'), tabs: 1, description: 'Berita terkini terkait dengan PT Asuransi Takaful Umum' },
        },
        {
          path: 'berita-detail/:url',
          name: 'berita-detail',
          component: () => import('@/views/newsdetail/Index.vue'),
          meta: { menubar: true, tabs: 1, description: 'Berita terkini terkait dengan PT Asuransi Takaful Umum' },
        },
        {
          path: 'jaringan',
          name: 'jaringan',
          component: () => import('@/views/network/Index.vue'),
          meta: { menubar: true, src: require('@/assets/banner-male.jpg'), tabs: 3, description: 'Total 17 Kantor Pemasaran Asuransi Takaful Umum tersebar dari Wilayah Barat sampai Timur Indonesia' },
        },
        {
          path: 'bengkel-rekanan',
          name: 'bengkel-rekanan',
          component: () => import('@/views/autoshop/Index.vue'),
          meta: { menubar: true, src: require('@/assets/banner-autoshop.jpg'), tabs: 3, description: 'Total 150 ++ Takaful Umum tersebar dari Wilayah Barat sampai Timur Indonesia' },
        },
        {
          path: 'pengaduan',
          name: 'pengaduan',
          component: () => import('@/views/complain/Index.vue'),
          meta: { menubar: true, src: require('@/assets/banner-complain.jpg'), tabs: 3, description: 'Form Pengaduan terkait dengan komplain, kritik maupun saran untuk PT Asuransi Takaful Umum lebih baik lagi' },
        },
        {
          path: 'karir',
          name: 'karir',
          component: () => import('@/views/career/Index.vue'),
          meta: { menubar: false, src: require('@/assets/pro.jpg'), tabs: 4, description: 'Jadilah bagian dari perjalanan yang memberdayakan dan memberi makna dalam dunia asuransi syariah bersama kami di Perusahaan Takaful Umum. Dengan budaya kerja yang inklusif, kesempatan pengembangan karir yang luas, dan komitmen terhadap nilai-nilai syariah, Anda akan memiliki kesempatan untuk terus berkembang dan memberikan kontribusi positif bagi masyarakat melalui layanan asuransi yang berlandaskan keadilan dan keberkahan.' },
        },
        {
          path: 'karir-detail/:url',
          name: 'karir-detail',
          component: () => import('@/views/careerdetail/Index.vue'),
          meta: { menubar: false, src: require('@/assets/pro.jpg'), tabs: 4, description: 'Jadilah bagian dari perjalanan yang memberdayakan dan memberi makna dalam dunia asuransi syariah bersama kami di Perusahaan Takaful Umum. Dengan budaya kerja yang inklusif, kesempatan pengembangan karir yang luas, dan komitmen terhadap nilai-nilai syariah, Anda akan memiliki kesempatan untuk terus berkembang dan memberikan kontribusi positif bagi masyarakat melalui layanan asuransi yang berlandaskan keadilan dan keberkahan.' },
        },
        {
          path: 'karir-insan',
          name: 'karir-insan',
          component: () => import('@/views/careergroup/Index.vue'),
          meta: { menubar: true, src: require('@/assets/banner-career.jpg'), subtitle: 'Takaful Karyawan', tabs: 4, description: 'Jadilah bagian dari perjalanan yang memberdayakan dan memberi makna dalam dunia asuransi syariah bersama kami di Perusahaan Takaful Umum. Dengan budaya kerja yang inklusif, kesempatan pengembangan karir yang luas, dan komitmen terhadap nilai-nilai syariah, Anda akan memiliki kesempatan untuk terus berkembang dan memberikan kontribusi positif bagi masyarakat melalui layanan asuransi yang berlandaskan keadilan dan keberkahan.' },
        },
        {
          path: 'karir-agen',
          name: 'karir-agen',
          component: () => import('@/views/careergroup/Index.vue'),
          meta: { menubar: true, src: require('@/assets/banner-agen.jpg'), subtitle: 'Takaful Marketing Executive', tabs: 4, description: 'Jadilah bagian dari perjalanan yang memberdayakan dan memberi makna dalam dunia asuransi syariah bersama kami di Perusahaan Takaful Umum. Dengan budaya kerja yang inklusif, kesempatan pengembangan karir yang luas, dan komitmen terhadap nilai-nilai syariah, Anda akan memiliki kesempatan untuk terus berkembang dan memberikan kontribusi positif bagi masyarakat melalui layanan asuransi yang berlandaskan keadilan dan keberkahan.' },
        },
        {
          path: 'karir-magang',
          name: 'karir-magang',
          component: () => import('@/views/careergroup/Index.vue'),
          meta: { menubar: true, src: require('@/assets/banner-magang.jpg'), subtitle: 'Takaful Magang', tabs: 4, description: 'Jadilah bagian dari perjalanan yang memberdayakan dan memberi makna dalam dunia asuransi syariah bersama kami di Perusahaan Takaful Umum. Dengan budaya kerja yang inklusif, kesempatan pengembangan karir yang luas, dan komitmen terhadap nilai-nilai syariah, Anda akan memiliki kesempatan untuk terus berkembang dan memberikan kontribusi positif bagi masyarakat melalui layanan asuransi yang berlandaskan keadilan dan keberkahan.' },
        },
        {
          path: 'polistakaful/:type/:id/:data',
          name: 'polistakaful',
          component: () => import('@/views/policy/Index.vue'),
          meta: { menubar: false, src: require('@/assets/pro.jpg') },
        },
        {
          path: 'klaim',
          name: 'klaim',
          component: () => import('@/views/claim/Index.vue'),
          meta: { menubar: true, src: require('@/assets/banner-claim.jpg') },
        },
        {
          path: 'faq',
          name: 'faq',
          component: () => import('@/views/faq/Index.vue'),
          meta: { menubar: true, src: require('@/assets/banner-faq.jpg'), tabs: 3 },
        },
        {
          path: 'perbedaan-takaful-dengan-konvensional',
          name: 'perbedaan-takaful-dengan-konvensional',
          component: () => import('@/views/different/Index.vue'),
          meta: { menubar: true, src: require('@/assets/banner-differents.jpg'), tabs: 3 },
        },
        {
          path: 'akun',
          name: 'akun',
          component: () => import('@/views/account/Index.vue'),
          meta: { menubar: false },
        },
        {
          path: 'login',
          name: 'login',
          component: () => import('@/views/login/Index.vue'),
          meta: { menubar: false },
        },
        {
          path: 'vcard/:id',
          name: 'vcard',
          component: () => import('@/views/vcard/Index.vue'),
          meta: { menubar: false },
        },
        {
          path: 'wbs',
          name: 'wbs',
          component: () => import('@/views/wbs/Index.vue'),
          meta: { menubar: true, src: require('@/assets/banner-wbs.jpg'), tabs: 4, description: 'Kami menghargai integritas dan kejujuran sebagai pondasi utama dalam menjaga kepercayaan dan keadilan. Jika Anda mengetahui atau memiliki kecurigaan terhadap tindakan fraud atau pelanggaran yang dilakukan oleh karyawan atau direksi di Perusahaan Takaful Umum, kami mengundang Anda untuk berani melangkah maju. Laporkan dengan percaya diri dan aman, karena kami memiliki mekanisme pengaduan yang rahasia dan akan menangani setiap laporan dengan serius, untuk menjaga integritas dan kredibilitas perusahaan serta mendukung keadilan' },
        },
        {
          path: 'kalkulator-kontribusi',
          name: 'kalkulator-kontribusi',
          component: () => import('@/views/calculator/Index.vue'),
          meta: { menubar: false, src: require('@/assets/pro.jpg') },
        },
        {
          path: 'kalkulator-kontribusi-bank',
          name: 'kalkulator-kontribusi-bank',
          component: () => import('@/views/calculator_bank/Index.vue'),
          meta: { menubar: false, src: require('@/assets/pro.jpg'), requiresBankContribution: true },
        },
        {
          path: 'verify-policy',
          name: 'verify-policy',
          component: () => import('@/views/verifypolicy/Index.vue'),
          meta: { menubar: false, src: require('@/assets/pro.jpg') },
        },
        {
          path: 'pegadaian',
          name: 'pegadaian',
          component: () => import('@/views/pegadaian/Index.vue'),
          meta: { menubar: false },
        },
        {
          path: 'bju',
          name: 'bju',
          component: () => import('@/views/bju/Index.vue'),
          meta: { menubar: false },
        },
        {
          path: 'suretyship',
          name: 'suretyship',
          component: () => import('@/views/suretyship/Index.vue'),
          meta: { menubar: false },
        },
        {
          path: 'scan',
          name: 'scan',
          component: () => import('@/views/scan/Index.vue'),
          meta: { menubar: false },
        },
        {
          path: 'pamudik',
          name: 'pamudik',
          component: () => import('@/views/pamudik/Index.vue'),
          meta: { menubar: true },
        },
        {
          path: 'policyvalidation/:type/:params',
          name: 'policyvalidation',
          component: () => import('@/views/policyvalidation/Index.vue'),
          props: true,
          meta: {
            menubar: true, tabs: 0, description: 'PT Asuransi Takaful Umum Merupakan Pionir Dalam Perusahaan Asuransi Umum Syariah Yang Telah Melayani Masyarakat Indonesia Sejak 1995'
          }
        },
        {
          path: 'gop',
          name: 'gop',
          component: () => import('@/views/gop/Index.vue'),
          meta: { menubar: true },
        },
        {
          path: 'anggaran-dasar',
          name: 'anggaran-dasar',
          component: () => import('@/views/articlesassociation/Index.vue'),
          meta: { menubar: true, src: require('@/assets/banner-anggaran.jpg'), tabs: 1, description: 'Anggaran Dasar PT Asuransi Takaful Umum' },
        },
        {
          path: 'perizinan',
          name: 'perizinan',
          component: () => import('@/views/permission/Index.vue'),
          meta: { menubar: true, src: require('@/assets/banner-perizinan.jpg'), tabs: 1, description: 'Perizinan PT Asuransi Takaful Umum' },
        },
        {
          path: 'under-maintenance',
          name: 'under-maintenance',
          component: () => import('@/views/undermaintenance/Index.vue'),
          meta: { menubar: true, src: require('@/assets/banner-anggaran.jpg'), tabs: 1, description: 'Anggaran Dasar PT Asuransi Takaful Umum' },
        },
        {
          path: 'marketingexecutive',
          name: 'marketingexecutive',
          component: () => import('@/views/marketingexecutive/Index.vue'),
          meta: { menubar: true, src: require('@/assets/banner-marketingexecutive.jpeg'), tabs: 3, description: 'Marketing Executive PT Asuransi Takaful Umum' },
        },
        {
          path: 'procedure',
          name: 'procedure',
          component: () => import('@/views/procedure/Index.vue'),
          meta: { menubar: true, src: require('@/assets/banner-prosedur.jpg'), tabs: 3, description: 'Prosedur dan Cara Bertransaksi di PT Asuransi Takaful Umum' },
        },
        {
          path: '*',
          name: 'FourOhFour',
          component: () => import('@/views/404/Index.vue'),
          meta: { menubar: true },
        },
      ],
    },

  ],
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(route => route.meta && route.meta.requiresBankContribution)) {
    if (isBankContributionUser()) {
      next()
      return
    }

    next({ name: 'login' })
    return
  }

  next()
})

export default router
